import { render, staticRenderFns } from "./Importacaoapp.vue?vue&type=template&id=b1bd2de2&scoped=true"
import script from "./Importacaoapp.vue?vue&type=script&lang=js"
export * from "./Importacaoapp.vue?vue&type=script&lang=js"
import style0 from "./Importacaoapp.vue?vue&type=style&index=0&id=b1bd2de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bd2de2",
  null
  
)

export default component.exports